import { icon } from "../functions/icons";
import { StandardComp } from "../atoms/standardComp";
import { GridLayout, HorizontalLayout, VerticalLayout } from "./layout";

export function ScoreOverview({ data, title = "Score overzicht", compact = false }) {

    return (
        <VerticalLayout className={`${compact ? '' : 'standard-margin-bottom'} not-clickable`} style={compact ? { height: 'auto', marginBottom: 0 } : undefined}>
            <StandardComp 
                editClass={"no-margin-right"}
            content={
                <>
                <h6 className="standard-small-margin-bottom standard-text-color">{title}</h6>
            <StandardComp
            editClass={"no-margin-right"}
             style={{ backgroundColor: data.is_passed ? "var(--success-500)" : "var(--error-500)" }}
            content={
                <>
                <VerticalLayout style={{     
                    alignContent: "center",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--white)",
                    }}>
                      {icon(data.is_passed ? "finished" : "x-circle", 40)}
                    <p style={{ fontSize: "1.4rem", fontWeight: "600", textAlign: "center" }}> {data.is_passed ? "Geslaagd!" : "Gezakt!"}</p>
                </VerticalLayout>
                </>
            }
           />
            <GridLayout columnsTemplate="repeat(auto-fit, minmax(220px, 1fr))" gap="1rem" className="standard-margin-top">
                    <StandardComp
                        editClass={"score-overview-card no-margin-right"}
                        content={
                            <>
                            {icon("star", 25, "var(--primary-500)")}
                            <p style={{ fontSize: "0.875rem", fontWeight: "300" }} className="standard-margin">Testvragen</p>
                            <p style={{ fontSize: "1rem", fontWeight: "600", textAlign: "center", width: "35%",}}>{data.passed_questions}/{data.total_questions} goed beantwoord!</p>
                            </>
                        }
                    />
                    <StandardComp
                        editClass={"score-overview-card no-margin-right"}
                        content={
                            <>
                            {icon("clock", 25, "var(--primary-500)")}
                            <p style={{ fontSize: "0.875rem", fontWeight: "300" }} className="standard-margin">Tijdslimiet</p>
                            <p style={{ fontSize: "1rem", fontWeight: "600" , textAlign: "center" , width: "35%",}}>{data.on_time ? "Binnen de tijd klaar!" : "Te laat ingeleverd!"}</p>
                            </>
                        }
                    />
                    <StandardComp
                        editClass={"score-overview-card no-margin-right"}
                        content={
                                <>
                                {icon("brain", 25, "var(--primary-500)")}
                                <p style={{ fontSize: "0.875rem", fontWeight: "300" }} className="standard-margin">Skills</p>
                                <p style={{ fontSize: "1rem", fontWeight: "600", textAlign: "center" , width: "35%", }}>{data.passed_questions ? data.passed_questions : "Geen"} skills geleerd!</p>
                                </>
                            }
                    />
            </GridLayout>
                </>
            }/>
        </VerticalLayout>
    );
}
